import React from 'react';
import classNames from 'classnames';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import pluralize from 'rebook/apps/utils/text/pluralize';
import CatalogNicheItem from 'rebook/apps/catalog/components/CatalogNicheItem';

import styles from './style.scss';


const NicheCatalogListCarousel = ({ niches, onClick }) => (
  <div className={classNames('billetContainerNoOverflow', styles.nicheListCarousel)}>
    {niches
      ? (
        <React.Fragment>
          <div className="billetContainerWrapper">
            <div className={styles.name}>
              <div>
                <div className="title-2">Жанры</div>
                <span className={styles.subtitle}>
                  {niches.length} {pluralize(niches.length, 'жанр', 'жанра', 'жанров')}
                </span>
              </div>
              <div onClick={() => onClick()}>
                <span className={classNames('link', styles.linkName)}>Все жанры</span>
                <span className="shortArrow" />
              </div>
            </div>
          </div>
          <ContentCarousel>
            {niches.map((niche) => (
              <div className={classNames('swiper-slide', styles.nicheCarouselItem)} key={niche.id}>
                <CatalogNicheItem niche={niche} />
              </div>
            ))}
          </ContentCarousel>
        </React.Fragment>
      )
      : (
        <div className={styles.nicheListEmpty}>
          <div className="billetContainerWrapper">
            <div className={styles.nameEmpty} />
          </div>
          <ContentCarousel withNav>
            {[...Array(6)].map((item, key) => (
              <div className={classNames('swiper-slide', styles.nicheCarouselItemEmpty)} key={key} />
            ))}
          </ContentCarousel>
        </div>
      )}
  </div>
);

export default NicheCatalogListCarousel;
